import React from 'react';
import { Box, Text } from 'grommet';
import PropTypes from 'prop-types';

const InactiveStatusMessages = {
    inactive: ' is inactive.',
    international: ' requires a visa to work in the US.',
    offboarded: ' was offboarded.',
};

export const InactiveStatus = ({ contact }) => {
    const displayInactiveStatus = [
        'inactive',
        'international',
        'offboarded',
    ].includes(contact.attributes.enrichProgramStatus);

    if (!displayInactiveStatus) return null;

    return (
        <Box
            align="center"
            background="white"
            border={{
                color: 'red',
                size: '3px',
            }}
            gap="small"
            justify="center"
            pad="medium"
            round="6px">
            <Text>
                {contact.attributes.firstName}{' '}
                {InactiveStatusMessages[contact.attributes.enrichProgramStatus]}
            </Text>
        </Box>
    );
};

InactiveStatus.propTypes = {
    contact: PropTypes.shape({
        id: PropTypes.string,
        attributes: PropTypes.shape({
            enrichProgramStatus: PropTypes.string,
            firstName: PropTypes.string,
        }),
    }),
};
